import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import Swal from 'sweetalert2'
import moment from 'moment'
import { useConfig } from '../../context/Config/ConfigContext'
import { useCart } from '../../context/Cart/CartContext'
import { useAuth } from '../../context/Auth/AuthContext'
import { api } from '../../services/api'
import ShipmentInfo from '../../components/ShipmentInfo'
import PaymentInfo from '../../components/PaymentInfo'
import CheckoutResume from '../../components/CheckoutResume'
import { getCarrierId } from '../../utils/auxFunc'

const CheckoutContainer = () => {
  const { userData } = useAuth()
  const { config } = useConfig()
  const {
    cart,
    getTotalByComponents,
    getTotalQuantity,
    getTotalAmount,
    clear
  } = useCart()
  const [updateUserDbData, setUpdateUserDbData] = useState(false)

  const [shipmentCost, setShipmentCost] = useState({
    shipmentCost: 0,
    dolarValue: 0
  })
  const [states, setStates] = useState()
  const [banks, setBanks] = useState()
  const [deliveryTimes, setDeliveryTimes] = useState()
  const [errorMessages, setErrorMessages] = useState({
    deliveryTime: {
      status: false,
      message: 'debe seleccionar un horario de entrega'
    },
    destinationForm: {
      status: false,
      message: 'debe completar todos los datos de envío'
    }
  })
  const [activeStep, setActiveStep] = useState(0)
  const [addresses, setAddresses] = useState([])
  const [buyerForm, setBuyerForm] = useState({
    clientName: userData.userName,
    clientPhone: userData.clientPhone,
    clientEmail: userData.userEmail,
    clientCuit: userData.clientDocNumber
  })
  const [shipmentForm, setShipmentForm] = useState({
    shipmentOption: 'sucursal',
    shipmentMethod: 4
  })
  const [withdrawalDate, setWithdrawalDate] = useState({
    withdrawalDate: nextDayEnabled()
  })
  const [destinationForm, setDestinationForm] = useState({
    clientAddressDescrp: 'principal',
    clientAddress: userData.clientAddress || '', //shopAddress
    clientFloor: userData.clientFloor || '', //addressFloor
    clientDoor: userData.clientDoor || '', //addressDoor
    clientCity: userData.clientCity || '', //shopCity
    clientStateName: userData.clientStateName || '', //shopState
    clientStateId: userData.clientStateId || 0,
    clientZipCode: userData.clientZipCode || '', //shopCP
    clientTranspoName: userData.clientTranspoName || '' //transportName
  })
  const [paymentForm, setPaymentForm] = useState({
    paymentMethod: userData.clientPaymentMethodId,
    paymentDescription: userData.clientPaymentMethod,
    bankId: null,
    bankName: null
  })
  const [deliveryTimeOfProduct, setDeliveryTimeOfProduct] = useState({
    deliveryId: 0,
    description: ''
  })

  const [observationsCheckout, setObservationsCheckout] = useState({
    observationsField: ''
  })
  const [carriers, setCarriers] = useState()
  const [paymentMethods, setPaymentMethods] = useState()
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm()

  const handleChange = ({ target }) => {
    setDeliveryTimeOfProduct({
      deliveryId: target.value,
      description: deliveryTimes.find(
        (time) => time.deliveryId === target.value
      ).description
    })
    setErrorMessages((prevState) => ({
      ...prevState,
      deliveryTime: { ...prevState.deliveryTime, status: false }
    }))
  }

  const handleObservationsFieldChange = (event) => {
    setObservationsCheckout({
      ...observationsCheckout,
      [event.target.name]: event.target.value
    })
  }

  const navigate = useNavigate()

  function nextDayEnabled() {
    if (new Date().getDay() === 5) {
      return moment().add(4, 'days').toDate()
    } else if (new Date().getDay() === 6) {
      return moment().add(3, 'days').toDate()
    } else {
      return moment().add(2, 'days').toDate()
    }
  }

  const updateData = () => {
    const newUserData = { ...destinationForm }
    newUserData.clientTranspoId = parseInt(
      carriers.find((carrier) => carrier.name === newUserData.clientTranspoName)
        ?.id
    )
    newUserData.clientId = userData.clientId
    newUserData.userId = userData.userId

    api.account
      .updateUserAddress(newUserData)
      .then((data) => {
        if (data.status !== 200) {
          Swal.fire({
            customClass: {
              confirmButton: 'swalBtnOk',
              title: 'swalTitle'
            },
            position: 'left',
            icon: 'success',
            title: 'Se han guardado sus datos',
            width: '350px',
            showConfirmButton: true,
            focusConfirm: false,
            iconColor: '#36A160',
            color: '#292929',
            background: '#FAFAFA',
            confirmButtonColor: 'rgb(230, 11, 19)'
          })
        }

        // getUserData();
      })
      .catch((err) => console.log(err))
  }

  const handleNext = async () => {
    let nextStep = false

    let data

    if (activeStep === 0) {
      const address =
        shipmentForm.shipmentOption === 'sucursal'
          ? 'randomAddress'
          : `${destinationForm.clientAddress.replace(
              /[\/?&=#%+@!$'()*;[\]_~]/g,
              ''
            )}`

      if (
        (shipmentForm.shipmentOption === 'caba' ||
          shipmentForm.shipmentOption === 'interiorDomicilio' ||
          shipmentForm.shipmentOption === 'interiorSucursal') &&
        (destinationForm.clientAddress === '' ||
          destinationForm.clientZipCode === '' ||
          destinationForm.clientTranspoName === '')
      ) {
        setErrorMessages((prevState) => ({
          ...prevState,
          destinationForm: { ...prevState.destinationForm, status: true }
        }))
        return
      }
      console.log({ address })
      if (
        shipmentForm.shipmentOption === 'caba' &&
        deliveryTimeOfProduct.deliveryId === 0
      ) {
        setErrorMessages((prevState) => ({
          ...prevState,
          deliveryTime: { ...prevState.deliveryTime, status: true }
        }))
        return
      }
      if (address !== ' ') {
        data = {
          clientAddressDescrp: destinationForm.clientAddressDescrp,
          clientAddress: address,
          clientCity: destinationForm.clientCity,
          clientFloor: destinationForm.clientFloor,
          clientDoor: destinationForm.clientDoor,
          clientZipCode: destinationForm.clientZipCode,
          clientTranspoId:
            destinationForm.clientTranspoName &&
            getCarrierId(carriers, destinationForm.clientTranspoName),
          deliveryTime: deliveryTimeOfProduct.deliveryId,
          shippingObservations: observationsCheckout.observationsField
        }
      }
      const tzoffset = new Date().getTimezoneOffset() * 60000 //offset in milliseconds
      const withdrawalDateISOLocale = new Date(
        withdrawalDate.withdrawalDate - tzoffset
      )
        .toISOString()
        .slice(0, -1)

      try {
        nextStep = await api.checkout
          .shippingMethod(
            userData.clientId,
            shipmentForm.shipmentMethod.toString(),
            address,
            withdrawalDateISOLocale,
            data
          )
          .then((data) => {
            if (data.status !== 200) {
              return Swal.fire({
                title: 'Error!',
                text: `Intente nuevamente`,
                icon: 'error'
              })
            }
            if (updateUserDbData) {
              updateData()
            }
            return true
          })
      } catch (err) {
        return Swal.fire({
          title: 'Error!',
          text: `Intente nuevamente
          ${err.message}`,
          icon: 'error'
        })
      }
    } else {
      const paymentData = {
        idPayment: paymentForm.paymentMethod,
        idBank: paymentForm.bankId,
        discount: paymentForm.paymentMethod === 1 ? 7 : 0
      }

      try {
        nextStep = await api.checkout
          .paymentMethod(userData.clientId, paymentData)
          .then((data) => {
            if (data.status !== 200) {
              return Swal.fire({
                title: 'Error!',
                text: `Intente nuevamente`,
                icon: 'error'
              })
            }
            return true
          })
      } catch (err) {
        console.log(err.message)
      }
    }

    if (nextStep === true) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1)
      nextStep = false
    }
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const checkout = () => {
    api.checkout
      .confirm(userData)
      .then((res) => {
        if (!res.ok)
          throw new Error({
            status: 404,
            message: 'No se pudo conectar al servidor'
          })
        return res.json()
      })
      .then((data) => {
        if (data.length > 0) {
          return Swal.fire({
            title: 'No se pudo finalizar la compra!',
            html: `
							<div>${data.length > 1 ? 'Productos' : 'Producto'} con stock insuficiente
								<ul>
									${data.map((product) => `<li>SKU: ${product.sku}</li>`).join('')}
								</ul>
							</div>`,
            showConfirmButton: true,
            icon: 'error'
          }).then((_) => navigate('/cart'))
        }
        Swal.fire({
          customClass: {
            confirmButton: 'swalBtnOkCkout',
            cancelButton: 'swalBtnCancelCkout',
            title: 'swalTitleCkout',
            container: 'swalTextSize'
          },
          position: 'center',
          icon: 'success',
          title: 'Tu pedido fue realizado',
          text: `Podes revisar el estado de tu pedido desde la sección: "Mi cuenta"`,
          width: '350px',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Continuar comprando',
          cancelButtonText: 'Ver mis pedidos',
          focusConfirm: false,
          iconColor: '#36A160',
          color: '#292929',
          background: '#FAFAFA',
          confirmButtonColor: '#292929',
          cancelButtonColor: '#FAFAFA'
        }).then((result) => {
          if (result.value) {
            navigate('/')
            clear()
          } else {
            navigate('/user-account')
            clear()
          }
        })
      })
      .catch((err) => {
        if (err.status === 404) {
          Swal.fire({
            title: 'Error!',
            text: `Error al finalizar la compra. ${err.message}`,
            icon: 'error'
          })
        }
      })
  }

  const confirmOrder = () => {
    if (
      getTotalAmount() < config?.shipmentInfo?.monto &&
      shipmentForm.shipmentOption !== 'sucursal'
    ) {
      api.checkout
        .addShipmentCost(userData, shipmentCost.shipmentCost)
        // .then((res) => res.json())
        .then((data) => {
          if (data.status !== 200) {
            // Swal.fire({
            //  customClass: {
            //    confirmButton: "swalBtnOkCkout",
            //    title: "swalTitleCkout",
            //    container: "swalTextSize",
            //  },
            //  position: "center",
            //  icon: "error",
            //  title: "Tu pedido fue realizado",
            //  text: "Error al finalizar la compra. Intente nuevamente",
            //  width: "350px",
            //  showConfirmButton: true,
            //  confirmButtonText: "Ok",
            //  focusConfirm: false,
            //  iconColor: "#36A160",
            //  color: "#292929",
            //  background: "#FAFAFA",
            //  confirmButtonColor: "#292929",
            // }).then(() => {
            //  return;
            // });
            Swal.fire({
              title: 'Error!',
              text: `Error al finalizar la compra. Intente nuevamente`,
              icon: 'error'
            })
          }
          checkout()
        })
        .catch((err) =>
          Swal.fire({
            title: 'Error!',
            text: `Error al finalizar la compra. Intente nuevamente`,
            icon: 'error'
          })
        )
    } else {
      checkout()
    }
  }

  useEffect(() => {
    if (!userData.clientAddress || !userData.clientZipCode) {
      setUpdateUserDbData(true)
    }

    api.utilities
      .getCarriers()
      .then((response) => response.json())
      .catch((err) => console.log(err))
      .then(setCarriers)
      .catch((err) => console.log(err))

    api.checkout
      .getPaymentMethods()
      .then((res) => res.json())
      .catch((err) => console.log(err))
      .then((paymentMethodsAPI) => {
        const filteredPaymentMethods = paymentMethodsAPI.filter(
          (pm) => pm.idPaymentCondition !== 8 && pm.idPaymentCondition !== 20
        )
        setPaymentMethods(filteredPaymentMethods)
      })
      .catch((err) => console.log(err))

    api.checkout
      .getBanks()
      .then((res) => res.json())
      .catch((err) => console.log(err))
      .then(setBanks)
      .catch((err) => console.log(err))

    api.checkout
      .deliveryTime()
      .then((res) => res.json())
      .catch((err) => console.log(err))
      .then((deliveryTimesAPI) => {
        setDeliveryTimes(deliveryTimesAPI)
        if (userData.clientDeliveryTimeId !== 0) {
          const description = deliveryTimesAPI?.find(
            (times) => times.deliveryId === userData.clientDeliveryTimeId
          ).description

          setDeliveryTimeOfProduct({
            deliveryId: userData.clientDeliveryTimeId,
            description
          })
        }
      })
      .catch((err) => console.log(err))

    api.utilities
      .getStates()
      .then((res) => res.json())
      .catch((err) => console.log(err))
      .then(setStates)
      .catch((err) => console.log(err))

    api.account
      .getUserAddresses(userData)
      .then((response) => response.json())
      .catch((err) => console.log(err))
      .then((data) => {
        setAddresses(data)
      })
      .catch((err) => console.log(err))

    if (getTotalAmount() < config.shipmentInfo?.monto) {
      api.checkout
        .getShipmentCost(userData.clientPriceListId)
        .then((res) => res.json())
        .catch((err) => console.log(err))
        .then(setShipmentCost)
        .catch((err) => console.log(err))
    }

    return () => {
      setCarriers()
    }
  }, [
    config.shipmentInfo?.monto,
    getTotalAmount,
    userData,
    userData.clientAddress,
    userData.clientPriceListId
  ])

  const closeCheckout = () => {
    navigate('/cart')
  }

  switch (activeStep) {
    case 0:
      return (
        <ShipmentInfo
          addresses={addresses}
          freeShippingAmount={config.shipmentInfo?.monto}
          shipmentCost={shipmentCost}
          deliveryTimes={deliveryTimes}
          buyerForm={buyerForm}
          setBuyerForm={setBuyerForm}
          shipmentForm={shipmentForm}
          setShipmentForm={setShipmentForm}
          withdrawalDate={withdrawalDate}
          setWithdrawalDate={setWithdrawalDate}
          destinationForm={destinationForm}
          setDestinationForm={setDestinationForm}
          carriers={carriers}
          states={states}
          getTotalAmount={getTotalAmount}
          register={register}
          handleSubmit={handleSubmit}
          Controller={Controller}
          control={control}
          errors={errors}
          closeCheckout={closeCheckout}
          activeStep={activeStep}
          handleNext={handleNext}
          deliveryTimeOfProduct={deliveryTimeOfProduct}
          handleChange={handleChange}
          observationsCheckout={observationsCheckout}
          handleObservationsFieldChange={handleObservationsFieldChange}
          errorMessages={errorMessages}
        />
      )
    case 1:
      return (
        <PaymentInfo
          shipmentCost={shipmentCost}
          banks={banks}
          paymentMethods={paymentMethods}
          paymentForm={paymentForm}
          setPaymentForm={setPaymentForm}
          register={register}
          closeCheckout={closeCheckout}
          getTotalAmount={getTotalAmount}
          activeStep={activeStep}
          handleNext={handleNext}
          handleBack={handleBack}
          shipmentForm={shipmentForm}
        />
      )
    case 2:
      return (
        <CheckoutResume
          shipmentCost={shipmentCost}
          cart={cart}
          buyerForm={buyerForm}
          shipmentForm={shipmentForm}
          withdrawalDate={withdrawalDate}
          destinationForm={destinationForm}
          paymentForm={paymentForm}
          getTotalByComponents={getTotalByComponents}
          getTotalQuantity={getTotalQuantity}
          getTotalAmount={getTotalAmount}
          closeCheckout={closeCheckout}
          activeStep={activeStep}
          handleBack={handleBack}
          deliveryTimes={deliveryTimes}
          deliveryTimeOfProduct={deliveryTimeOfProduct}
          observationsCheckout={observationsCheckout}
          confirmOrder={confirmOrder}
          clear={clear}
        />
      )
    default:
      ;<h1>Paso inexistente</h1>
  }
}

export default CheckoutContainer
